import { render, staticRenderFns } from "./Charts.vue?vue&type=template&id=36171000"
import script from "./Charts.vue?vue&type=script&lang=js"
export * from "./Charts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports